<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Histórico de transacciones')"
      icono="mdi-archive"
      tabla="histra"
      :campos="['id_histra-', 'id_apicar-', 'tra', 'codins-', 'id_ins', 'numcarins', 'id_car', 'inicar', 'fincar', 'ultact-', 'kwhcar', 'coscar', 'datadi-']"
      :campos-filtrables="['id_apicar', 'id_ins', 'id_car', 'inicar', 'fincar']"
      busqueda-rapida
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gescar");
    }
  },
};
</script>

<style>
</style>